// extracted by mini-css-extract-plugin
export default {"root":"exchange-page_root__gZum3","title":"exchange-page_title__9Mbwg","buttonNormal":"exchange-page_buttonNormal__T-y-2","buttonError":"exchange-page_buttonError__KEK-F"};